/**
 * Fills `{{ ... }}` merge fields with sample values for the editor's live
 * preview, so the preview reads like a received email instead of showing
 * template syntax. The real per-recipient values are filled in at send time
 * (packages/core send/personalize.ts); nothing here is sent.
 */
const SAMPLE_VALUES: Record<string, string> = {
  'contact.first_name': 'Anna',
  'contact.last_name': 'Jensen',
  coupon_code: 'SAMPLE10',
  flow_coupon_code: 'SAMPLE10',
};

/** `{{ field }}` or `{{ field | default: "x" }}`; quotes may already be HTML-escaped in block HTML. */
const TAG =
  /\{\{\s*([a-z0-9_.]+)\s*(?:\|\s*default:\s*(?:"|&quot;|&#34;)(.*?)(?:"|&quot;|&#34;)\s*)?\}\}/g;

export function fillPreviewMergeFields(source: string): string {
  return source.replace(TAG, (_m, field: string, fallback: string | undefined) => {
    const sample = SAMPLE_VALUES[field];
    if (sample !== undefined) return sample;
    // Link fields (unsubscribe_url, view_url, ...) become inert links in the preview.
    if (field.endsWith('_url')) return '#';
    return fallback ?? '';
  });
}
